// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i7rvUZ{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;flex-direction:column;justify-content:center}.r3w4I_{margin-bottom:20px}.XnIX9z{margin-top:10px;display:flex;align-items:center;justify-content:center;direction:ltr}@media (max-width: 449px){.XnIX9z{margin-top:0}}.XnIX9z>div{margin:0 20px}@media (max-width: 599px){.XnIX9z>div{margin:0 15px}}@media (max-width: 449px){.XnIX9z>div{margin:0 12px}}.XnIX9z button{border:0;padding:0;line-height:0;height:21px;width:30px;background:none;cursor:pointer;color:white;transition:color 0.3s ease;display:block}.XnIX9z button:hover{color:#BABABA}.XnIX9z button:disabled{color:#767676 !important}.ejWNRM{height:21px}.ejWNRM svg{width:24px;height:100%}@media (max-width: 599px){.ejWNRM{height:16px}}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `i7rvUZ`,
	"select": `r3w4I_`,
	"share-buttons": `XnIX9z`,
	"shareButtons": `XnIX9z`,
	"icon": `ejWNRM`
};
export default ___CSS_LOADER_EXPORT___;
